import * as React from 'react';

import { FIELD_PATHS } from '@funnels/constants';
import { AssetEntityIndex } from '@funnels/types';

import { DollarInputField, NumeralDisplay } from '../../Fields';
import { EditableViewProps, NumericalReadOnlyViewProps } from '../types';

interface AssetValueEditableViewProps extends EditableViewProps, AssetEntityIndex {
  label?: string;
  disableFailMessage?: boolean;
}

export const AssetValueEditableView = (props: AssetValueEditableViewProps) => {
  const { label, assetIndex, ...rest } = props;

  return <DollarInputField {...rest} name={FIELD_PATHS.ASSET_ESTIMATED_VALUE(assetIndex)} label={label} isZeroValid />;
};

export const AssetValueReadOnlyView = (props: NumericalReadOnlyViewProps) => <NumeralDisplay before={'$'} {...props} />;
